import React from "react"
import { MobileTabbar } from "../../../widgets/mobile-tabbar/components/mobile-tabbar.js"
import { MobileDrawerProvider } from "../../../contexts/mobile-drawer-context.js"
import { useIsMobile } from "../../../hooks/useIsMobile.js"
import { LoadingOverlay } from "../feedback/loading/components/loading-overlay.js"
import { NewLayoutTopBar } from "./new-layout-top-bar.js"
import { Sidebar } from "./sidebar/components/sidebar.js"
import { useSidebar } from "./sidebar/hooks/use-sidebar.js"

/**
 * Componente interno que usa o hook useSidebar
 * @param {Object} props - Props do componente
 * @param {React.ReactNode} props.children - Conteúdo do layout
 * @returns {React.ReactElement} Layout interno
 */
function AppLayoutContent({ children }) {
  const sidebarState = useSidebar()
  const isMobile = useIsMobile()

  return React.createElement(
    "div",
    { 
      style: { 
        display: "flex",
        height: "100vh",
        backgroundColor: "#f5f7ff",
        overflow: "hidden"
      } 
    },
    React.createElement(Sidebar, { ...sidebarState }),
    React.createElement(
      "div",
      { 
        style: { 
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
          overflow: "hidden"
        } 
      },
      React.createElement(NewLayoutTopBar, null),
      React.createElement(
        "div",
        { 
          style: { 
            flex: 1, 
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden" 
          } 
        },
        React.createElement(
          "div",
          {
            style: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              overflow: "hidden"
            }
          },
          children
        ),
        isMobile ? React.createElement(MobileTabbar, { variant: "solid" }) : null
      )
    ),
    React.createElement(LoadingOverlay)
  )
}

/**
 * Layout principal da aplicação
 * @param {Object} props - Props do componente
 * @param {React.ReactNode} props.children - Conteúdo do layout
 * @returns {React.ReactElement} Layout principal da aplicação
 */
export function AppLayout({ children }) {
  return React.createElement(
    MobileDrawerProvider,
    null,
    React.createElement(AppLayoutContent, { children })
  )
}